// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface FileImagesIconSignature {
  Element: SVGSVGElement;
}

export const FileImagesIcon: TOC<FileImagesIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5 1.00101H16.414L21 5.58701V21.001C21 22.104 20.103 23.001 19 23.001H5C3.897 23.001 3 22.104 3 21.001V3.00101C3 1.89801 3.897 1.00101 5 1.00101ZM5 3.00101V21.001H19.001L19 7.00101H15V3.00101H5ZM12 16.002L10 14.002L7 18.002H17L14 12.002L12 16.002ZM11.4142 12.4162C12.1952 11.6352 12.1952 10.3688 11.4142 9.5878C10.6332 8.80675 9.36682 8.80675 8.58577 9.5878C7.80472 10.3688 7.80472 11.6352 8.58577 12.4162C9.36682 13.1973 10.6332 13.1973 11.4142 12.4162Z"/>
</svg>
</template>;